import moment from 'moment'

const data = [
  {
    id: '001',
    formName: 'test-form-01',
    formCode: 'test-form-01',
    sigle: 1,
    savePdf: 0,
    visible: 1,
    linkReport: {
      name: 'ipd report',
      code: 'ipdReport',
    },
    category: {
      name: 'IPD',
      code: 'ipd',
      visible: 0,
    },
    version: {
      name: '2023 (default)',
      code: '2023',
      visible: 1,
    },
    createdBy: 'test',
    createdDate: moment().format('DD-MM-YYYY'),
    enabled: true,
    data: {
      completedHtml:
        '<h3>Thank you for your feedback.</h3><h5>Your thoughts and ideas will help us to create a great product!</h5>',
      completedHtmlOnCondition: [
        {
          expression: '{nps_score} > 8',
          html:
            '<h3>Thank you for your feedback.</h3><h5>We glad that you love our product. Your ideas and suggestions will help us to make our product even better!</h5>',
        },
        {
          expression: '{nps_score} < 7',
          html:
            '<h3>Thank you for your feedback.</h3><h5> We are glad that you share with us your ideas.We highly value all suggestions from our customers. We do our best to improve the product and reach your expectation.</h5><br />',
        },
      ],
      pages: [
        {
          name: 'page1',
          elements: [
            {
              type: 'rating',
              name: 'nps_score',
              title:
                'On a scale of zero to ten, how likely are you to recommend our product to a friend or colleague?',
              isRequired: true,
              rateMin: 0,
              rateMax: 10,
              minRateDescription: '(Most unlikely)',
              maxRateDescription: '(Most likely)',
            },
            {
              type: 'checkbox',
              name: 'promoter_features',
              title: 'Which features do you value the most?',
              isRequired: true,
              validators: [
                {
                  type: 'answercount',
                  text: 'Please select two features maximum.',
                  maxCount: 2,
                },
              ],
              choices: [
                'Performance',
                'Stability',
                'User Interface',
                'Complete Functionality',
              ],
              showOtherItem: true,
              otherText: 'Other feature:',
              colCount: 2,
            },
            {
              type: 'comment',
              name: 'passive_experience',
              title: 'What do you like about our product?',
            },
            {
              type: 'comment',
              name: 'disappointed_experience',
              visible: false,
              visibleIf: '{nps_score} notempty',
              title:
                'What do you miss or find disappointing in your experience with our products?',
            },
          ],
        },
      ],
    },
  },
  {
    id: '002',
    formName: 'test-form-02',
    formCode: 'test-form-02',
    sigle: 1,
    savePdf: 0,
    visible: 1,
    linkReport: {
      name: 'opd report',
      code: 'opdReport',
    },
    category: {
      name: 'OPD',
      code: 'opd',
      visible: 0,
    },
    version: {
      name: '2023 (default)',
      code: '2023',
      visible: 1,
    },
    createdBy: 'test report',
    createdDate: moment().format('DD-MM-YYYY'),
    enabled: true,
    data: {
      title: 'Test Survey',
      logoPosition: 'right',
      pages: [
        {
          name: 'page1',
          elements: [
            {
              type: 'checkbox',
              name: 'question1',
              choices: ['item1', 'item2', 'item3'],
            },
            {
              type: 'dropdown',
              name: 'question2',
              choices: ['item1', 'item2', 'item3', 'item4'],
            },
            {
              type: 'text',
              name: 'question3',
            },
            {
              type: 'text',
              name: 'question4',
            },
            {
              type: 'text',
              name: 'question5',
            },
            {
              type: 'imagepicker',
              name: 'question6',
              choices: [
                {
                  value: 'lion',
                  imageLink:
                    'https://surveyjs.io/Content/Images/examples/image-picker/lion.jpg',
                },
                {
                  value: 'giraffe',
                  imageLink:
                    'https://surveyjs.io/Content/Images/examples/image-picker/giraffe.jpg',
                },
                {
                  value: 'panda',
                  imageLink:
                    'https://surveyjs.io/Content/Images/examples/image-picker/panda.jpg',
                },
                {
                  value: 'camel',
                  imageLink:
                    'https://surveyjs.io/Content/Images/examples/image-picker/camel.jpg',
                },
              ],
            },
          ],
        },
      ],
    },
  },
]

export default data
